<template>
  <div class="styleGuide">
    <div class="styleGuide__header">
      <h1 class="large-title">Style Guide</h1>
      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis magnam doloribus placeat adipisci vitae, quis ratione quaerat debitis iusto atque sed similique necessitatibus odit quibusdam provident, magni aspernatur corrupti minus?</p>
    </div>
    <pre>
      <span class="tag">&lt;template&gt;</span>
      
      <span class="tag">&lt;/template&gt;</span>

      <span class="tag">&lt;script&gt;</span>
      <span class="tag">import</span> <span class="module">anything</span> <span class="tag">from</span> <span class="variable">'path'</span> 
        
        <span class="module">name</span>: <span class="variable">'adx-anything'</span>,
        <span class="module">components</span>: {
          <span class="module">'aaa-bbb-ccc'</span>: <span class="variable">Anything</span>
        },
        <span class="module">props</span>: {
          <span class="module">anything</span>: {
            <span class="module">type</span>: String,
            <span class="module">required</span>: false,
            <span class="module">default</span>: <span class="variable">'ADX Asia'</span>
          }
        },
        <span class="function">data</span>() {
          return {
            variable: 'value',
            variable: [value],
            variable: {value}
          }
        },
        <span class="module">computed</span>: {
          <span class="function">greeting</span>() {
            <span class="tag">return</span> `This is <span class="tag">${</span>this.variable<span class="tag">}</span>` <span class="comment"> 
            //You should use `` instead '' for merger string with variable (string interpolation)</span>
          }
        },
        <span class="module">watch</span>: {

        },
        <span class="function">beforeCreate</span>() {

        },
        <span class="function">created</span>() {

        },
        <span class="function">beforeMount</span>() {

        },
        <span class="function">mounted</span>() {
          this.someFunction()
        },
        <span class="function">beforeUpdate</span>() {

        },
        <span class="function">updated</span>() {

        },
        <span class="function">activated</span>() {

        },
        <span class="function">deactivated</span>() {

        },
        <span class="function">beforeDestroy</span>() {

        },
        <span class="function">destroyed</span>() {

        },
        <span class="module">methods</span>: {
          <span class="function">someFunction</span>() {
            console.log('Hello ADX Asia')
          }
        }

      <span class="tag">&lt;/script&gt;</span>

      <span class="tag">&lt;style</span> <span class="function">lang</span>=<span class="variable">'scss'</span> <span class="function">scoped</span><span class="tag">&gt;</span>
      <span class="tag">@import</span> <span class="variable">'./index.scss';</span>
      <span class="tag">&lt;/style&gt;</span>
    </pre>
    
  </div>
</template>

<script>
import Anything from 'path'

export default {
  name: 'adx-style-guide',
  components: {
    'aaa-bbb-ccc': Anything
  },
  props: {
    anything: {
      type: String,
      required: false,
      default: 'ADX Asia'
    }
  },
  data() {
    return {

    }
  },
  computed: {
    asd(){
      return `asd ${this.vas}`
    }
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.someFunction()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    someFunction() {
      console.log('Hello ADX')
    }
  }

}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
